import React, {useEffect} from 'react'
import {useLocation} from 'react-router-dom'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import PageLoader from '../../components/page-loader'
import useEinstein from '@salesforce/retail-react-app/app/hooks/use-einstein'
import {useServerContext} from '@salesforce/pwa-kit-react-sdk/ssr/universal/hooks'
import Optimizely from '../../components/optimizely'
import {MAX_CACHE_AGE_L, STALE_WHILE_REVALIDATE_L} from '../../constants'
import {useOptimizelyPage} from '../../hooks/use-optimizely-page'

const PrivacyPolicy = () => {
    const einstein = useEinstein()
    const {res} = useServerContext()
    const {pathname} = useLocation()

    if (res) {
        res.set(
            'Cache-Control',
            `s-maxage=${MAX_CACHE_AGE_L}, stale-while-revalidate=${STALE_WHILE_REVALIDATE_L}`
        )
    }

    // Request privacy policy content from Optimizely
    const {data: optimizelyData, isLoading: isOptimizelyLoading} = useOptimizelyPage('grg-web-uk---privacy-policy')

    useEffect(() => {
        einstein.sendViewPage(pathname)
    }, [pathname, einstein])

    if (isOptimizelyLoading) {
        return (
            <Box data-testid="privacy-policy-page" layerStyle="page" pb={0}>
                <PageLoader />
            </Box>
        )
    }

    return (
        <Box data-testid="privacy-policy-page" layerStyle="page" pb={0}>
            <Optimizely content={optimizelyData?.page || optimizelyData} isLoading={isOptimizelyLoading} />
        </Box>
    )
}

PrivacyPolicy.getTemplateName = () => 'privacy-policy'

export default PrivacyPolicy